module.exports = __webpack_public_path__ + "img/kcjs-kcxf.0cd7ca9e.png";